import { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router";
import styles from "./SignUp.module.css";
import  {useAuth} from "../../context/AuthContext";
import { Toast } from 'primereact/toast';
import { useForm } from 'react-hook-form';

import Loading from './../Loading/Loading';

export const SignUp = () => {
  const { signUp} = useAuth();
  const [dataForm, setDataForm] = useState({});
  const history = useHistory('/');
  const toast = useRef();
  //const cuitRegex= RegExp(/^(20|23|24|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/g);
  let [loading, setLoading] = useState(false);

  const showErrorRegister = (myError) => {
    toast.current.show({ severity: 'error', summary: 'Error de Registro', detail: myError, life: 3000 });
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://kit.fontawesome.com/64d58efce2.js";
    script.async = true;
    document.body.appendChild(script);
  }, [])

  const handleLogin = (e) => {
    history.replace('/login'); //Usando replace NO dejo huella en el Hisroty de la ruta actual
  };

  const handleRegister = async () => {
    try{
     // e.preventDefault();
      setLoading(true);

      await signUp(dataForm.emailReg, dataForm.passwordReg,dataForm.cuilReg);
      history.replace('/'); //Usando replace NO dejo huella en el Hisroty de la ruta actual
      setLoading(false);
    }
    catch (err) {
      showErrorRegister(err);
     // setError('Error de Registro!');
      // setTimeout(() => {
      //   setError('')
      // }, 1500);
      setLoading(false);
    }
  };


  const onSubmit = (data) =>{
    //console.log (data);
    handleRegister();
  }

  const handleChange = (e) => {
    setDataForm({
      ...dataForm,
      [e.target.name]:e.target.value,
    });
  };
  
// useEffect(() => {
//     console.log ({errors});
//   }, [{errors}])

  const {register,handleSubmit, formState: { errors }} = useForm();

  return (
    <div> {loading && <Loading />}
      <div className={`${styles.body} ${styles.container}`} id="container">
        <Toast ref={toast} />
        <div className={styles.formsContainer}>
          <div className={styles.signinSignup}>
            <form  onSubmit={handleSubmit(onSubmit)}>
            <img src="assets/images/plasti.png" className={styles.imagePlasti}  alt="" />
            <p/>
              <p className={styles.title} style={{ fontSize: '35px' }} > <b>Registrarse</b></p>

              <div className={styles.inputField}>
                <i class="fas fa-envelope"></i>
                <input 
                  type="email" 
                  placeholder="Email" 
                  name= "emailReg" 
                  {...register("emailReg", { 
                    required:{
                      value: true,
                      message: 'Campo obligatorio'
                    }
                  })} 
                  onChange= {handleChange}/>
              </div>
              <span className={styles.colorError}>{errors?.emailReg?.message}</span>

              <div className={styles.inputField}>
                <i class="fas fa-lock"></i>
                <input 
                  type="password" 
                  placeholder="Contraseña" 
                  name= "passwordReg" 
                  {...register("passwordReg", { 
                    required: {
                      value: true,
                      message: 'Campo obligatorio'
                    }, 
                    minLength:{
                      value: 6,
                      message: 'Mínimo 6 caracteres'
                    }
                  })} 
                  onChange = {handleChange}/>
              </div>
              <span className={styles.colorError}>{errors?.passwordReg?.message}</span>

              <div className={styles.inputField}>
                {/* <i class="fas fa-user"></i> */}
                <i class="fas fa-ellipsis-h"></i>
                <input 
                  type="text" 
                  placeholder="CUIL (SIN guiones)" 
                  name = "cuilReg" 
                  {...register("cuilReg", { 
                    pattern:{
                      value:/^(20|23|24|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/g,
                      message:'No es un CUIL válido'
                    },
                    required: { 
                      value: true,
                      message: 'Campo obligatorio',
                    },
                    maxLength:{
                      value: 11,
                      message: 'Máximo 11 caracteres'
                    }
                  })}   
                  onChange = {handleChange}/>
              </div>
              <span className={styles.colorError}>{errors?.cuilReg?.message}</span>

              <input type="submit" className={styles.btn} value="REGISTRARSE" />
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/> 
              <br/> 
              <br/> 

            </form>
          </div>
          <div className={styles.containerBottom}>

          </div>
        </div>

        <div className={styles.panelsContainer}>
          <div className={`${styles.panel} ${styles.leftPanel}`}>
            <div className={styles.content}>
              <div className={styles.fontSizeH3}>Ya posee cuenta?</div>
              {/* <div className={styles.fontSizeParrafo}>Bienvenido, para registrarse pulse el siguiente boton!</div>
              <p/> */}
              <p className={styles.nota}>Si tiene cuenta solo pulse <b>"INGRESAR"</b></p>
              <button className={`${styles.btn} ${styles.transparent} ${styles.fontSizeBoton}`} id="sign-up-btn" onClick={handleLogin} >
              Ingresar
                </button>
            </div>
            <img src="assets/images/register.svg" className={styles.image} alt="" />
          </div>
        </div>
      </div >
    </div>
  )
}